// The values a multi-select holds that its options no longer offer — an
// option disabled after it was picked (the options list leaves disabled
// options out, as Jira's does). The editor gives each a ticked row so it can
// be unticked; unticked, it leaves the value and with it the list, so it
// cannot be picked again.
//
// Matched by id, as the editor's selectedIds is; a value with no id is left
// out (it has never had a row).
//
//   retiredValues(value, options) → [{ ...value, retired: true }]

export function retiredValues(value, options) {
  const offeredIds = new Set((options || []).map(opt => String(opt.id || opt.value)));
  return (Array.isArray(value) ? value : [])
    .filter(v => v != null && (typeof v === 'object' ? v.id != null : true))
    .filter(v => !offeredIds.has(String(typeof v === 'object' ? v.id : v)))
    .map(v => (typeof v === 'object' ? { ...v, retired: true } : { id: v, value: String(v), retired: true }));
}
